<script setup lang="ts">
  import { Skeleton } from "@ui-kit";
</script>

<template>
  <div class="zoning-skeleton" data-testid="zoning-skeleton">
    <div v-for="i in 5" :key="i" class="zoning-skeleton__item">
      <Skeleton width="48px" height="62px" />
      <div class="zoning-skeleton__info">
        <Skeleton width="244px" height="20px" />
        <Skeleton width="199px" height="18px" />
        <Skeleton width="74px" height="16px" />
      </div>
    </div>
  </div>
</template>

<style scoped>
  .zoning-skeleton {
    display: flex;
    flex-direction: column;
    padding: 16px;
    gap: 4px;
    background-color: var(--sf-base-background-primary);
    position: absolute;
    top: 92px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }

  .zoning-skeleton__item {
    display: flex;
    gap: 12px;
    padding: 12px;
    border-radius: 16px;
    background-color: var(--sf-base-background-white);

    :deep(.skeleton) {
      border-radius: 8px;
    }
  }

  .zoning-skeleton__info {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
</style>
